<div class="container mx-auto p-6">
  <h2 class="text-3xl font-semibold text-center mb-6">Documentos</h2>

  <div class="flex justify-between items-center mb-4">
    <button
      (click)="goBack()"
      class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded"
    >
      Volver
    </button>
  </div>

  <div class="flex justify-between items-center mb-4">
    <div>
      <label class="block font-medium mb-1 text-gray-500"
        >Unidad Funcional</label
      >
      <select
        [(ngModel)]="selectedUnidadFuncional"
        (change)="onUnidadFuncionalChange()"
        class="border border-gray-300 rounded py-2 px-4 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-400"
      >
        <option value="">Todos</option>
        <option
          *ngFor="let unidad of unidadesFuncionales"
          [value]="unidad.id_unidad_funcional"
        >
          {{ unidad.nombre }}
        </option>
      </select>
    </div>

    <div>
      <label class="block font-medium mb-1 text-gray-500">Oficina</label>
      <select
        [(ngModel)]="selectedOficina"
        (change)="fetchDocuments()"
        class="border border-gray-300 rounded py-2 px-4 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-400"
      >
        <option value="">Todos</option>
        <option
          *ngFor="let oficina of oficinasFiltradas"
          [value]="oficina.id_oficina"
        >
          {{ oficina.nombre }}
        </option>
      </select>
    </div>
    <div>
      <label class="block font-medium mb-1 text-gray-500">Ordenar por fecha límite</label>
      <select
        [(ngModel)]="selectedDateOrder"
        (change)="fetchDocuments()"
        class="border border-gray-300 rounded py-2 px-4 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-400"
      >
        <option value="">Orden Predeterminado</option>
        <option value="ASC">Próximos a vencer (↑)</option>
        <option value="DESC">Lejanos a vencer (↓)</option>
      </select>
    </div>
    <div>
      <label class="block font-medium mb-1 text-gray-500">Estado</label>
      <select
        [(ngModel)]="selectedStatus"
        (change)="fetchDocuments()"
        class="border border-gray-300 rounded py-2 px-4 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-400"
      >
        <option value="">Todos</option>
        <option value="PENDIENTE">Pendiente</option>
        <option value="INICIADO">Iniciado</option>
        <option value="OBSERVADO">Observado</option>
        <option value="RECTIFICADO">Rectificado</option>
        <option value="PROCESO">Proceso</option>
        <option value="LOGRADO">Logrado</option>
      </select>
    </div>

    <div>
      <label class="block font-medium mb-1 text-gray-500">Buscar</label>
      <div class="relative">
        <input
          type="text"
          class="border border-gray-300 rounded py-2 px-4 pl-10 pr-4 w-full focus:outline-none focus:ring-2 focus:ring-blue-400"
          placeholder="Nombre o ID..."
          [(ngModel)]="searchText"
          (input)="applyFilter()"
        />
        <i class="fas fa-search absolute top-3 left-3 text-gray-500"></i>
      </div>
    </div>
  </div>

  <div class="overflow-x-auto">
    <table class="min-w-full border-collapse border border-gray-200">
      <thead>
        <tr class="bg-gray-100 text-left">
          <th class="py-2 px-4 border-b border-gray-200">ID</th>
          <th class="py-2 px-4 border-b border-gray-200">Nombre</th>
          <th class="py-2 px-4 border-b border-gray-200">Fecha de Fin</th>
          <th class="py-2 px-4 border-b border-gray-200">Tipo Documento</th>
          <th class="py-2 px-4 border-b border-gray-200">Oficina</th>
          <th class="py-2 px-4 border-b border-gray-200">Estado</th>
          <th class="py-2 px-4 border-b border-gray-200">Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let doc of getPaginatedDocuments()"
          class="hover:bg-gray-50 transition"
        >
          <td class="py-2 px-4 border-b border-gray-200">
            {{ doc.id_documento }}
          </td>
          <td class="py-2 px-4 border-b border-gray-200">{{ doc.nombre }}</td>
          <td class="py-2 px-4 border-b border-gray-200">
            {{ doc.fecha_fin | date : "dd/MM/yyyy" }}
          </td>
          <td class="py-2 px-4 border-b border-gray-200">
            {{ doc.tipo_documento }}
          </td>
          <td class="py-2 px-4 border-b border-gray-200">
            {{ doc.oficina.nombre }}
          </td>
          <td class="py-2 px-4 border-b border-gray-200">
            {{ doc.documentos_cargados[0]?.estado || "PENDIENTE" }}
          </td>
          <td class="py-2 px-4 border-b border-gray-200">
            <button
              class="bg-green-500 hover:bg-green-600 text-white font-semibold py-1 px-3 rounded"
              *ngIf="doc.documentos_cargados[0]?.estado; else registrarTemplate"
              (click)="goToDocumentDetail(doc)"
            >
              Ver
            </button>
            <ng-template #registrarTemplate>
              <button
                class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-1 px-3 rounded"
                (click)="goToRegisterPage(doc)"
              >
                Registrar
              </button>
            </ng-template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="flex justify-between items-center mt-6">
    <button
      class="hover:bg-gray-300 border text-gray-800 py-2 px-4 rounded"
      [disabled]="currentPage === 1"
      (click)="changePage(currentPage - 1)"
    >
      Anterior
    </button>
    <span class="text-gray-700"
      >Página {{ currentPage }} de {{ totalPages }}</span
    >
    <button
      class="hover:bg-gray-300 border text-gray-800 py-2 px-4 rounded"
      [disabled]="currentPage === totalPages"
      (click)="changePage(currentPage + 1)"
    >
      Siguiente
    </button>
  </div>
</div>
